import { render, staticRenderFns } from "./managePartnerDetails.pug?vue&type=template&id=15240339&scoped=true&lang=pug&"
import script from "./managePartnerDetails.ts?vue&type=script&lang=ts&"
export * from "./managePartnerDetails.ts?vue&type=script&lang=ts&"
import style0 from "./managePartnerDetails.scss?vue&type=style&index=0&id=15240339&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15240339",
  null
  
)

export default component.exports